import { useCallback } from 'react';

/**
 * Hook that provides a function to trigger scrolling to the top of the page.
 * Uses an anchor which should be placed in the target component.
 * Scrolls to the specified hash, and when the anchor is in view, removes the hash from the URL and disconnects the observer.
 */
export const useTriggerTopScroll = () => {
  const triggerTopScroll = useCallback((hash: string = 'top') => {
    window.location.hash = hash;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.history.replaceState(null, '', ' ');
          observer.disconnect();
        }
      });
    });

    const topElement = document.querySelector(`#${hash}`);
    if (topElement) {
      observer.observe(topElement);
    }
  }, []);

  return triggerTopScroll;
};
